import { useCallback, useSyncExternalStore } from "react";

const STORAGE_KEY = "clerical-theme";

function subscribe(cb: () => void) {
	window.addEventListener("storage", cb);
	return () => window.removeEventListener("storage", cb);
}

function getSnapshot(): boolean {
	return localStorage.getItem(STORAGE_KEY) === "dark";
}

function applyTheme(dark: boolean) {
	document.documentElement.classList.toggle("dark", dark);
	document.documentElement.style.colorScheme = dark ? "dark" : "light";
}

export function useDarkMode() {
	const isDark = useSyncExternalStore(subscribe, getSnapshot);

	const toggle = useCallback(() => {
		const next = !getSnapshot();
		localStorage.setItem(STORAGE_KEY, next ? "dark" : "light");
		applyTheme(next);
		window.dispatchEvent(new StorageEvent("storage"));
	}, []);

	// Keep DOM in sync with stored state
	applyTheme(isDark);

	return { isDark, toggle };
}
